export default __webpack_public_path__ + "static/sample-0ab200114306b892f1e046e36d786eca.mp3";